'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var label = null,
        placeholder = '',
        attributes = void 0,
        input = null,
        classList = this.compileStyle(_index2.default);

    if (this.props.label) {
        label = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { className: classList.labelHolder },
                '\xA0'
            ),
            _react2.default.createElement(
                'label',
                { className: classList.label },
                this.props.label
            )
        );
    }

    if (this.props.placeholder && (!this.props.floating ||
    // material: ph виден если нет лейбла
    !this.props.label ||
    // material: ph виден в состоянии фокуса, если есть лейбл
    this.state.focus)) {
        placeholder = this.props.placeholder;
    }

    var _props = this.props,
        autoComplete = _props.autoComplete,
        autoFocus = _props.autoFocus,
        disabled = _props.disabled,
        id = _props.id,
        name = _props.name,
        onKeyDown = _props.onKeyDown,
        onKeyUp = _props.onKeyUp,
        onChange = _props.onChange,
        readOnly = _props.readOnly,
        type = _props.type,
        maxLength = _props.maxLength,
        attribute = _props.attribute,
        defaultValue = _props.defaultValue;


    attributes = {
        className: classList.field,
        value: this._stringify(),
        onBlur: this._handleBlur,
        onFocus: this._handleFocus,
        placeholder: placeholder,
        ref: this._createRef
    };

    return _react2.default.createElement(
        'div',
        {
            className: classList.root + ' ' + (this.props.className || ''),
            onMouseEnter: this._handleHover,
            onMouseLeave: this._handleRootBlur
        },
        label,
        _react2.default.createElement('input', _extends({
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            onKeyUp: onKeyUp,
            onKeyDown: onKeyDown,
            onChange: onChange,
            disabled: disabled,
            id: id,
            name: name,
            type: type,
            readOnly: readOnly,
            maxLength: maxLength,
            defaultValue: defaultValue,
            'data-qa-node': attribute,
            'data-qa-value': attributes.value
        }, attributes)),
        _react2.default.createElement('hr', { className: classList.border }),
        _react2.default.createElement('hr', { className: classList.activeBorder })
    );
}